<template>
  <div class="table">
    <table>
      <thead class="none">
        <tr>
          <td v-if="items.notifications"></td>
            <td v-if="items.checkbox == true">
              <div :class="['checkbox__box', selectAll ? 'selected' : '']" @click.stop="toggleSelectAll">
                <span class="checkbox__box__ic"><i class="adx-ic_check"></i></span>
              </div>
            </td>
            <td v-for="(item, index) in items.head" :key="index" class="title">
              <span :style="item.display">{{item.title}}</span>
            </td>
            <td v-if="items.menu"></td>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr v-for="(item, index) in items.body" :key="item.values[0].value" :title="titleText" @click.stop="selectedRow(item, index)">
          <td v-if="items.notifications" class="table__notification">
            <template v-if="items.notifications[index]">
              <div v-if="items.notifications[index].type === 'warning'" class="adx-ic_warning yellow"></div>
              <div v-if="items.notifications[index].type === 'new'" class="red-dot"></div>
            </template>
          </td>
          <td v-if="items.checkbox == true" @click.stop="toggleSelect(item.values[0].value)">
            <div :class="['checkbox__box', isSelected(item.values[0].value) ? 'selected' : '']">
                <span class="checkbox__box__ic"><i class="adx-ic_check large-font"></i></span>
            </div>
          </td>
          <td v-for="(value, number) in item.values" :key="number" class="table__item">
            <span v-if="items.head[number].type == 'text'" class="text" :style="value.display">{{value.value}}</span>
            <span v-else-if="items.head[number].type == 'text-value'" class="value text">{{value.label}}</span>
            <div v-else-if="items.head[number].type == 'description'" class="description">
              <div v-for="(item, index) in value.items" :key="index">
                <b v-if="value.header == true && index == 0">{{item.value}}</b>
                <span v-else>{{item.value}}</span>
              </div>
              <div class="label_hover" @click.stop="goToAction(item, index)" >
                <span class='mini-font color-pink' v-if="value.labelLink == true" >{{value.label}}</span>
              </div>
            </div>
            <div v-else-if="items.head[number].type == 'multipletext'" class="multiple-text">
              <div v-for="(item, index) in value.items" :key="index">
                <div v-if="item.statuses" class="statuses">
                  <div v-for="(status, i) in item.statuses" :key="i">
                    <label-status :progress="status"/>
                  </div>
                </div> 
                <span v-else>{{item.value}}</span>
              </div>
            </div>
            <div v-else-if="items.head[number].type == 'multiplemoney'" class="multiple-money">
              <div v-for="(item, index) in value.items" :key="index">
                {{item.value | formatMoney}}
              </div>
            </div>
             <div v-else-if="items.head[number].type == 'multiplenumber'" class="multiple-number">
              <div v-for="(item, index) in value.items" :key="index">
                {{item.value | formatNumber}}
              </div>
            </div>
            <div v-else-if="items.head[number].type == 'checked'">
              <i v-if="value.value == true" class="adx-ic_check icon-check"></i>
            </div>
            <div v-else-if="items.head[number].type == 'button'">
                <tooltip :text="value.tooltip">
                  <div slot="content">
                    <button v-if="value.value == true" :disabled="value.disabled" class="btn-small secondary" @click="downloadBast(index, value, item)">
                    <i v-if="value.icon" class="icon-download"></i>
                    {{value.label}}
                    </button>
                  </div>
                </tooltip>
            </div>
            <div v-else-if="items.head[number].type == 'money'" class="money">
              <span>{{value.value | formatMoney}}</span>
            </div>
            <div v-else-if="items.head[number].type == 'number'" class="number">
              <span>{{value.value | formatNumber}}</span>
            </div>
            <div v-else-if="items.head[number].type == 'input'" class="inputed-type" >
              <input v-model="value.value" :placeholder="value.label ? value.label : 'input value ...'" 
                @input="selectedInput(index, item, $event.target.value)" :type="value.type">
                 <i :class="[value.icon ? value.icon  : '', 'backIcon icon-position']" v-if="value.icon"></i>
              <div v-if="value.isError" class="mini-font color-pink error-message">{{value.errorMessage}}</div>
            </div>
            <div v-else-if="items.head[number].type == 'dropdown'" >
              <adx-select-dropdown :options="dropdown" :isTable="true" :labelButton='`Vendor Name`' @selected="selectedDropdown($event, item)" :value.sync="value.value"/>
              <!-- <dropdown-ordinary  :list="dropdown" :labelButton='`Vendor Name`' @selected="selectedDropdown($event, item)" /> -->
            </div>
            <span v-else-if="items.head[number].type == 'date'" class="date">{{ value.value == '' ? '-' : displayDate(value.value) }}</span>
            <span v-else-if="items.head[number].type == 'period'" class="date">{{ value.start == '' && value.end == '' ? '-' : displayPeriod(value.start, value.end) }}</span>
            <span v-else-if="items.head[number].type == 'image'"><img :src="value.value" /></span>
            <label-status v-else-if="items.head[number].type == 'statuslabel'" :progress="value"/>
            <hover-icon  v-else-if="items.head[number].type == 'icon'" :icon='value.icon' :imgIcon='value.imgIcon' :text='value.text' :isDisabled="value.isDisabled" @selectedIcon="selectedIcon(number, value.icon, item, value.imgIcon)"/>
            <adx-breadcrumb-status v-else-if="items.head[number].type == 'indicatorStatus'" :isActive.sync='value.status' :items.sync="value.items"/>
          </td>
          <td v-if="items.menu" class="menu-action">
            <menu-expansion-status :lists="items.menu" @selected="selected($event, item, index, item.values[0].value)"/>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table__showmore">
      <slot class="table__showmore__loading" name="infiniteLoading"/>
    </div>
    <div class="emptyState">
      <adx-empty-selection class="emptyState__empty" v-if="isEmpty && !loading" />
    </div>
    <div v-if="loading" class="table__loadingWrapper">
      <slot name="loading" />
      <adx-loading/>
    </div>
  </div>
</template>

<script>
import EmptySelection from '@/components/NotFound/Selection'
import MenuExpansionStatus from '@/components/MenuExpansionStatus'
import Alert from "@/components/Alert"
import tooltip from '@/components/Tooltip'
import LabelStatus from '@/components/StatusLabel'
import IndicatorStatus from '@/components/Breadcrumb/IndicatorStatus'
import HoverIcon from '@/components/IconHover'
import Loading from '@/components/Loading/Primary'
import SelectDropdown from '@/components/Form/SelectDropdown'

import lib from '@/lib/util'

import * as validationLib from '@/lib/validation/'
import moment from 'moment'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-table',
  components: {
    'adx-empty-selection': EmptySelection,
    'label-status': LabelStatus,
    'adx-breadcrumb-status': IndicatorStatus,
    'menu-expansion-status': MenuExpansionStatus,
    'hover-icon': HoverIcon,
    'adx-loading': Loading,
    'tooltip': tooltip,
    'adx-select-dropdown': SelectDropdown,
  },
  props: {
    items: {
      required: false
    },
    loading: {
      required: false,
      default: false
    },
    isEmpty:{
      required: false,
      default: false
    },
    titleText:{
      required:false,
      default:''
    },
    dropdownItems:{
      type: Array,
      required:false,
    },
  },
  data() {
    return {
      isAction: false,
      selectAll: false,
      selectedItems: [],
      coba: [],
      dropdown: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.coba = this.items
    this.dropdown = this.dropdownItems
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectedIcon(id, type, item, imgIcon){
      this.$emit('selectedAction',id, type, item, imgIcon)
    },
    downloadBast(index, value, item){
      this.$emit('downloadBast',index, value, item)
      this.$emit('download',index, value, item)
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      // this.showLinkAllPage = !this.showLinkAllPage
      if (this.selectAll) {
        this.selectedItems = []
        for (const key of Object.keys(this.items.body)) {
            this.selectedItems.push(this.items.body[key].values[0].value)
        }
      } else {
        this.resetCheckbox()
      }
      this.$emit('selectedCheckbox',this.selectedItems)
    },
    toggleSelect(id) {
      if (this.isSelected(id)) {
        let index = this.selectedItems.indexOf(id)
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push(id)
      }
      if (this.selectedItems.length == this.items.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      this.$emit('selectedCheckbox',this.selectedItems)
    },
    isSelected(id) {
      let items = this.selectedItems.filter((itemID) => {
        return itemID == id
      })

      if (items.length > 0) {
        return true
      }

      return false
    },
    resetCheckbox() {
      this.selectedItems = []
      this.selectAll = false
    //   this.selectAllPage = false
    },
    selected(event, item, index, id){
      this.$emit('setItem', item)
      this.$emit('selected', event, index, id)
    },
    displayDate(date) {
      return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', date)}`
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    selectedRow(item, index){
      this.$emit('selectedRow', item, index)
    },
    goToAction(item, index){
      this.$emit('goToAction', item, index)
    },
    selectedInput(index, item, value){
      this.$emit('selectedInput', index, item, value)
    },
    selectedDropdown(value, item){
      // console.log(value, item)
      this.$emit('selectedDropdown', value, item)
    },
    inputValue(index){
      this.$emit('inputValue', index)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>

// .selectDropdown .select input{
//   min-height: 0px;
//   padding: 8px;
// }

//   .selectDropdown .select input:valid {
//     padding-top: 0px;
//   }

</style>
